import { AlignCenterVerticalIcon, PlusIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

import { AgencyFlowExportImportDropdown } from './agency-flow-export-import-dropdown.atom'

interface AgencyFlowCanvasControlsProps {
  onAutoLayout: () => void
  onAddNode: () => void
  onExport: () => void
  onImport: (file: File) => void
}

export const AgencyFlowCanvasControls = ({
  onAutoLayout,
  onAddNode,
  onExport,
  onImport,
}: AgencyFlowCanvasControlsProps): ReactNode => (
  <div className="agency-flow-panel flex gap-2">
    <Button
      variant="outline"
      size="sm"
      onClick={onAutoLayout}
      className="agency-flow-layout-button"
    >
      <AlignCenterVerticalIcon className="mr-1 size-4" />
      Auto Layout
    </Button>
    <Button variant="outline" size="sm" onClick={onAddNode} className="agency-flow-add-button">
      <PlusIcon className="mr-1 size-4" />
      Add Agent
    </Button>
    <AgencyFlowExportImportDropdown onExport={onExport} onImport={onImport} />
  </div>
)

AgencyFlowCanvasControls.displayName = 'AgencyFlowCanvasControls'
